import React from 'react';
import {toJS} from 'mobx';
import './index.scss';

//material-ui
import { Grid, CircularProgress, ListItem } from '@material-ui/core'

//api
import {api} from '../../functions/api'

//custom components
import InformationBox from '../../components/basic/informationBox'
import RightBox from '../../components/basic/rightBox'
import Graph from '../../components/complex/graph'
import CustomSnackbar from '../../components/global/snackbar';

//other libraries
import { inject, observer } from 'mobx-react';
import uuid from 'uuid4';
import moment from 'moment';
import Card from '@material-ui/core/Card'
import List from '@material-ui/core/List'
import CardHeader from '@material-ui/core/CardHeader'
import CardContent from '@material-ui/core/CardContent'
import CustomButton from '../../components/basic/CustomButton'
import Icon from '@mdi/react'
import { mdiCart, mdiHexagon, mdiStar } from '@mdi/js'

window.addEventListener('resize', () => {
    // We execute the same script as before
    let vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
  });
  
const TIMEOUT = 3000;

@inject('internal')
@inject('translate')
@observer
export default class Dashboard extends React.Component {
    
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            openSnackbar: false,
            message: "",
        }
    }

    turnOffSnackBar = () => {
        clearTimeout(this.timeout)
        this.timeout = setTimeout(() => {
            this.setState({
                message: "",
                openSnackbar: false
            })
        }, TIMEOUT)
    }

    timeout = null;
    componentWillUnmount() {
        clearTimeout(this.timeout)
    }
    

    informationBox = []

    adminBoxContent = []

    clientBoxContent = []
    
    widgetPages = []

    componentDidMount() {
        let redirectUrl = localStorage.getItem('url')
        if(redirectUrl) {
            localStorage.removeItem('url');
            this.props.internal.setRoute( this.props.history, redirectUrl)
            this.props.internal.pushRoute( redirectUrl)
            
        }
        else {
            this.props.internal.setRoute( this.props.history, this.props.location.pathname)
        }
        
        this.setState({message: toJS(this.props.internal.dataSnackbar.msg), openSnackbar:toJS(this.props.internal.dataSnackbar.open) })
        this.props.internal.setSnackbar(toJS(this.props.internal.dataSnackbar.msg), toJS(this.props.internal.dataSnackbar.open))
        this.turnOffSnackBar();
        
        // this.loadDashboardChart();
        if(toJS(this.props.internal.user.data.role.id) !== 6) {
            this.loadDashboard();
        }
    }

    formatMoney = (data) => {
        const formatter = new Intl.NumberFormat('sk-SK', {
            style: 'currency',
            currency: 'EUR',
            minimumFractionDigits: 2
        })
        return formatter.format(data)
    }

    loadDashboard = async () => {
        let load_data = await api({
            method: 'get',
            url: 'dashboard',
            authorization: this.props.internal.user.access_token,
        })

        if(load_data.success === true) {
            this.widgetPages = load_data.data.data.pages;
            
            this.props.internal.setDataForSimpeTable(load_data.data.data)
            if(toJS(this.props.internal.user) && toJS(this.props.internal.user.data.role) && (toJS(this.props.internal.user.data.role.id) < 3 || toJS(this.props.internal.user.data.role.id) === 5)) {
                this.informationBox.push(
                    {
                        title: this.props.translate.i18n.MODULES.DASHBOARD.ORDERS_MONTH,
                        content: toJS(this.props.internal.dataForSimpeTable.orders.this_month) && toJS(this.props.internal.dataForSimpeTable.orders.this_month.count) ? toJS(this.props.internal.dataForSimpeTable.orders.this_month.count) : 0
                    },
                    {
                        title: this.props.translate.i18n.MODULES.DASHBOARD.PRICE_MONTH,
                        content: this.formatMoney(toJS(this.props.internal.dataForSimpeTable.orders.this_month) && toJS(this.props.internal.dataForSimpeTable.orders.this_month.price) ? toJS(this.props.internal.dataForSimpeTable.orders.this_month.price) : 0)
                    },
                    {
                        title: this.props.translate.i18n.MODULES.DASHBOARD.ORDERS_YEAR,
                        content:toJS(this.props.internal.dataForSimpeTable.orders.this_year) && toJS(this.props.internal.dataForSimpeTable.orders.this_year.count) ? toJS(this.props.internal.dataForSimpeTable.orders.this_year.count) : 0
                    },
                    {
                        title: this.props.translate.i18n.MODULES.DASHBOARD.PRICE_YEAR,
                        content: this.formatMoney(toJS(this.props.internal.dataForSimpeTable.orders.this_year) && toJS(this.props.internal.dataForSimpeTable.orders.this_year.price) ? toJS(this.props.internal.dataForSimpeTable.orders.this_year.price) : 0)
                    }
                )
            
                this.adminBoxContent.push(
                    {
                        title: this.props.translate.i18n.GLOBAL.MENU.ADMINISTRATORS,
                        count: toJS(this.props.internal.dataForSimpeTable.count.admins) ? toJS(this.props.internal.dataForSimpeTable.count.admins) : 0,
                        url: "administrators"
                    },
                    {
                        title: this.props.translate.i18n.GLOBAL.MENU.CLIENTS,
                        count: toJS(this.props.internal.dataForSimpeTable.count.clients) ? toJS(this.props.internal.dataForSimpeTable.count.clients) : 0,
                        url: "clients"
                    },
                    {
                        title: this.props.translate.i18n.GLOBAL.MENU.CLIENTS_USERS,
                        count: toJS(this.props.internal.dataForSimpeTable.count.users) ? toJS(this.props.internal.dataForSimpeTable.count.users) : 0,
                        // link_to: ""
                    },
                    {
                        title: this.props.translate.i18n.GLOBAL.MENU.CLIENTS_BRANCHES,
                        count: toJS(this.props.internal.dataForSimpeTable.count.branches) ? toJS(this.props.internal.dataForSimpeTable.count.branches) : 0,
                        // link_to: ""
                    },
                    {
                        title: this.props.translate.i18n.GLOBAL.MENU.PRODUCTS,
                        count: toJS(this.props.internal.dataForSimpeTable.count.products) ? toJS(this.props.internal.dataForSimpeTable.count.products) : 0,
                        url: "products"
                    },
                    {
                        title: this.props.translate.i18n.GLOBAL.MENU.LAST_IMPORT,
                        // count: toJS(this.props.internal.dataForSimpeTable.import.created_at) ? dateformat(toJS(this.props.internal.dataForSimpeTable.import.created_at), "dd.mm.yyyy") : 0
                        count: toJS(this.props.internal.dataForSimpeTable.import.created_at) ? moment(toJS(this.props.internal.dataForSimpeTable.import.created_at)).format("DD.MM.YYYY") : 0

                    },
                )
            }

            else if(toJS(this.props.internal.user) && toJS(this.props.internal.user.data.role) && toJS(this.props.internal.user.data.role.id) > 2 && toJS(this.props.internal.user.data.role.id) !== 5) {
                let lastOrders = toJS(this.props.internal.dataForSimpeTable.orders.last).filter(order => order.items.filter(orderItem => null !== orderItem.product).length > 0);
                for(let i=0; i<lastOrders.length; i++) {
                    const orderItems = lastOrders[i].items.filter(orderItem => null !== orderItem.product)
                    for(let item = 0; item < orderItems.length; item++) {
                        this.clientBoxContent.push(
                            {
                                title: orderItems[item].product.name,
                                subtitle: this.formatMoney(orderItems[item].product.client_price),
                                url: `/products/${orderItems[item].product.id}/detail`
                            }
                        )
                    }
                }
                this.informationBox.push(
                    {
                        title: this.props.translate.i18n.MODULES.DASHBOARD.ORDERS_MONTH,
                        content: toJS(this.props.internal.dataForSimpeTable.orders.this_month) && toJS(this.props.internal.dataForSimpeTable.orders.this_month.count) ? toJS(this.props.internal.dataForSimpeTable.orders.this_month.count) : 0
                    },
                    {
                        title: this.props.translate.i18n.MODULES.DASHBOARD.PRICE_MONTH,
                        content: this.formatMoney(toJS(this.props.internal.dataForSimpeTable.orders.this_month) && toJS(this.props.internal.dataForSimpeTable.orders.this_month.price) ? toJS(this.props.internal.dataForSimpeTable.orders.this_month.price) : 0)
                    },
                    {
                        title: this.props.translate.i18n.MODULES.DASHBOARD.ORDERS_YEAR,
                        content:toJS(this.props.internal.dataForSimpeTable.orders.this_year) && toJS(this.props.internal.dataForSimpeTable.orders.this_year.count) ? toJS(this.props.internal.dataForSimpeTable.orders.this_year.count) : 0
                    },
                    {
                        title: this.props.translate.i18n.MODULES.DASHBOARD.PRICE_YEAR,
                        content: this.formatMoney(toJS(this.props.internal.dataForSimpeTable.orders.this_year) && toJS(this.props.internal.dataForSimpeTable.orders.this_year.price) ? toJS(this.props.internal.dataForSimpeTable.orders.this_year.price) : 0)
                    }
                )

                let clientId = toJS(this.props.internal.user.data.client.id)

                this.adminBoxContent.push(
                    {
                        title: this.props.translate.i18n.MODULES.CLIENTS.ORDERS,
                        count: toJS(this.props.internal.dataForSimpeTable.count) && toJS(this.props.internal.dataForSimpeTable.count.orders) ? toJS(this.props.internal.dataForSimpeTable.count.orders) : 0,
                        url: `clients/${clientId}/orders`
                    },
                    {
                        title: this.props.translate.i18n.GLOBAL.MENU.CLIENTS_USERS,
                        count: toJS(this.props.internal.dataForSimpeTable.count) && toJS(this.props.internal.dataForSimpeTable.count.users) ? toJS(this.props.internal.dataForSimpeTable.count.users) : 0,
                        url: `clients/${clientId}/users`
                    },
                    {
                        title: this.props.translate.i18n.GLOBAL.MENU.CLIENTS_BRANCHES,
                        count: toJS(this.props.internal.dataForSimpeTable.count) && toJS(this.props.internal.dataForSimpeTable.count.branches) ? toJS(this.props.internal.dataForSimpeTable.count.branches) : 0,
                        // link_to: "",
                        url: `clients/${clientId}/branches`
                    }
                    
                    
                )
            }
            this.setState({loading: false});
        }
        
    }
    
    
    render() {
        if (toJS(this.props.internal.user.data.role.id) === 6) {
            const permissions = toJS(this.props.internal.user.data.permissions);
            return (
              <Grid container spacing={16} direction={'column'} alignItems={'center'} className={'dashboard'}>
                  <CustomSnackbar
                    message={this.state.message}
                    open={this.state.openSnackbar}
                  />
                  {permissions.products && permissions.products.view ? (
                    <Grid item>
                      <CustomButton
                        href={'/products'}
                        mystyle={'btn-orange-bg border-radius-18'}
                        title={this.props.translate.i18n.GLOBAL.MENU.PRODUCTS}
                        justText
                      >
                          <Icon path={mdiCart} size={1}/>
                      </CustomButton>
                  </Grid>
                  ): null}
                  {permissions.issue_cards && permissions.issue_cards.view ? (
                  <Grid item>
                      <CustomButton
                        href={'/issue-cards'}
                        mystyle={'btn-orange-bg border-radius-18'}
                        title={this.props.translate.i18n.GLOBAL.MENU.ISSUE_CARDS}
                        justText
                      >
                          <Icon path={mdiStar} size={1}/>
                      </CustomButton>
                  </Grid>
                  ): null}
                  {permissions.stock_management && permissions.stock_management.view ? (
                  <Grid item>
                      <CustomButton
                        href={'/to-storage'}
                        mystyle={'btn-orange-bg border-radius-18'}
                        title={this.props.translate.i18n.GLOBAL.MENU.TO_STORAGE}
                        justText
                      >
                          <Icon path={mdiHexagon} size={1}/>
                      </CustomButton>
                  </Grid>
                  ): null}
              </Grid>
            )
        }
        
        return (
            this.state.loading
                ?
                <CircularProgress className = {'circular-progress'}/>
                :

            
            <Grid container className={'dashboard'}>
                <CustomSnackbar
                    message = {this.state.message}
                    open = {this.state.openSnackbar}
                />
                <Grid item xs={12} sm={12} md={8} className={'box-graph'}>
                    <div className={'graph'}>
                        <Graph/>
                    </div>
                    <Grid container spacing={16} className={'quick-info'}>
                    {this.informationBox.map((data) => {
                        return (
                            <Grid key={uuid()} item xs={12} sm={6} md={6} xl={3} >
                                {/* item xs={12} sm={12} md={4}  */}
                                <InformationBox title={data.title} content={data.content}/>
                            </Grid>
                        );
                    })}
                    </Grid>
                </Grid>
                <Grid item xs={12} md className={'box-last-ordered'}>
                    {this.widgetPages.length > 0 ? (<Card className={'dashboard-widget'}>
                        <CardHeader
                          title={this.props.translate.i18n.MODULES.DASHBOARD.WIDGET_NEWS}
                          titleTypographyProps={{className: 'dashboard-widget-title'}}
                          className={'dashboard-widget-header'} />
                        <CardContent className={'dashboard-widget-content'}>
                            <List>
                                {this.widgetPages.map(page => (
                                  <ListItem
                                    button
                                    key={page.slug}
                                    className={'dashboard-widget-item'}
                                    onClick={() => this.props.internal.pushRoute(`/static/${page.slug}`)}
                                  >
                                      {page.title}
                                  </ListItem>
                                ))}
                            </List>
                            
                        </CardContent>
                    </Card>): null}
                    {this.props.internal.user && this.props.internal.user.data.role && this.props.internal.user.data.role.id > 2
                        ?
                        <RightBox admin={true} countsForClient>
                            {this.adminBoxContent}
                        </RightBox>
                        :
                        null
                    }
                    
                    <RightBox admin={!! (this.props.internal.user && this.props.internal.user.data.role && (this.props.internal.user.data.role.id === 2 || this.props.internal.user.data.role.id === 5))}>
                        {this.props.internal.user && this.props.internal.user.data.role && this.props.internal.user.data.role.id === 2 ? this.adminBoxContent : this.clientBoxContent}
                    </RightBox>
                   
                    {/* <RightBox >
                        {clientBoxContent}
                    </RightBox> */}
                </Grid>
            </Grid>
        );
        
    }
}



// WEBPACK FOOTER //
// ./src/screens/dashboard/index.js